import { Tables } from "@/lib/supabase/supabase_types_override";

export const extractCommonQuestionProperties = (
  questionToExtractFrom:
    | Tables<"question">
    | Tables<"survey_bank_question_bank">
    | Tables<"question_bank">
) => {
  const {
    question,
    description,
    // selected_configuration
  } = questionToExtractFrom;
  return {
    question,
    description,
    // selected_configuration,
  };
};

export type ExtractCommonQuestionPropertiesType = ReturnType<
  typeof extractCommonQuestionProperties
>;